angular.module('jv.requisition.eQuest.controller', [])
.controller('ReqseQuestCtrl', ['$scope', 'Reqs', '$filter',
function ($scope, Reqs, $filter) {
    $scope.requisitions.eQuest = {};
    $scope.requisitions.eQuestData = {
        category: [],
        subCategoryGroup: [],
        subCategory: [],
        subSubCategory: []
    };

    $scope.flags = {};

    $scope.populateSubCategory = function (index) {
        switch (index) {
            case 1:
                var subCategoryGroup = $filter('filter')($scope.requisitions.eQuestData.category, {
                    CodeID: $scope.requisitions.eQuest.category
                });
                if (subCategoryGroup.length > 0) {
                    $scope.requisitions.eQuestData.subCategoryGroup = subCategoryGroup[0].ChildNodes;
                } else {
                    $scope.requisitions.eQuestData.subCategoryGroup = [];
                }
                $scope.requisitions.eQuestData.subCategory = [];
                $scope.requisitions.eQuestData.subSubCategory = [];
                break;
            case 2:
                var subCategory = $filter('filter')($scope.requisitions.eQuestData.subCategoryGroup, {
                    CodeID: $scope.requisitions.eQuest.subCategoryGroup
                });
                if (subCategory.length > 0) {
                    $scope.requisitions.eQuestData.subCategory = subCategory[0].ChildNodes;
                } else {
                    $scope.requisitions.eQuestData.subCategory = [];
                }

                $scope.requisitions.eQuestData.subSubCategory = [];
                break;
            case 3:
                var subSubCategory = $filter('filter')($scope.requisitions.eQuestData.subCategory, {
                    CodeID: $scope.requisitions.eQuest.subCategory
                });
                if (subSubCategory.length > 0) {
                    $scope.requisitions.eQuestData.subSubCategory = subSubCategory[0].ChildNodes;
                } else {
                    $scope.requisitions.eQuestData.subSubCategory = [];
                }
                break;
            default:
                // do nothing
        }
    };

    $scope.post = function () {
        if (!$scope.requisitions.eQuest.category) {
            return;
        }
        var postData = {
            categoryId: $scope.requisitions.eQuest.subSubCategory || $scope.requisitions.eQuest.subCategory || $scope.requisitions.eQuest.subCategoryGroup || $scope.requisitions.eQuest.category,
            loc: $scope.requisitions.selectedlocations
        };

        Reqs.postToeQuest($scope.requisitions.jobDetails.EId, postData, function (response) {
            var eQuestData = JSON.parse(response.bean),
                eQuestParamMap = JSON.parse(eQuestData.result);
            var form = $('<form/>').attr({
                name: 'eQuestPostForm',
                action: 'https://jobvite.equest.com/post/',
                target: '_self',
                method: 'POST'
            });
            for (var key in eQuestParamMap) {
                var input = $('<input/>').attr({
                        type: 'hidden'
                    }),
                    name = eQuestParamMap[key].Id,
                    value = eQuestParamMap[key].Value;
                if (/return_url|error_url/i.test(name)) {
                    value = response.jhireBaseUrl + '/action/requisition/' + $scope.requisitions.jobDetails.EId + '/jobboard/eQuest?functionId=' + (postData.categoryId) + '&i=' + $scope.params.index + '&c=' + $scope.params.count + '&q=' + $scope.params.query;
                    if (postData.loc) {
                        value += '&loc=' + postData.loc;
                    }
                }
                input.attr({
                    name: name,
                    value: value
                });
                form.append(input);
            }
            $('#container').append(form);
            document.eQuestPostForm.submit();
        });
    };

    $scope.getClass = function () {
        var category = Boolean($scope.requisitions.eQuest.category);
        return category ? 'btn' : 'btnGry';
    };
}]);